import { SectionHeading } from "@/components/SectionHeading";
import { ShopifyUrlForm } from "@/components/settings/ShopifyUrlForm";
import AdminGate from "@/components/admin/AdminGate";
import { STORE } from "@/constants/testIds";

const NarrowContainer = ({ children }) => (
  <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">{children}</div>
);

export default function Settings() {
  return (
    <div data-testid={STORE.settingsPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <NarrowContainer>
          <SectionHeading
            tone="navy"
            kicker="Store admin"
            title="Checkout link"
            subtitle="Paste your checkout, product, or cart URL here. Every Buy button on the site will redirect to it — no code changes needed."
          />
        </NarrowContainer>
      </section>

      <section className="py-14 sm:py-20">
        <NarrowContainer>
          <AdminGate>
            <ShopifyUrlForm />
          </AdminGate>
        </NarrowContainer>
      </section>
    </div>
  );
}
